<template>
  <div>
    <datatable
      :is_createable="false"
      title="Questions"
      @edit_click="editClick"
      @delete="deleteQuestion"
      :fields="fields"
      :response="data"
    >
    </datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import QuestionsHelper from '@/custom/classes/questions_helper.js'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'position-questions',
  data () {
    return {
      questions_helper: new QuestionsHelper(),
      position_id: this.$route.query.position_id,
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'designator',
          value: 'designator',
          css_classes: {
            mandatory_question: (row_data) => ['work_scope', 'seniority', 'job_title', 'is_discrete'].includes(row_data.designator)
          }
        },
        {
          name: 'applicant_text',
          value: 'info.applicant_text'
        },
        {
          name: 'importance',
          value: 'importance'
        },
        {
          name: 'answers',
          value: 'answers'
        }
      ],
      data: []
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils
        .getResourceQuestions({
          current_type: 'Position',
          current_resource_id: this.position_id,
          designators: this.questions_helper.getAllDesignators()
        })
        .then(response => {
          this.data = this.questions_helper.getQuestionsWithAnswers(response)
          this.data.sort(this.compareByImportance)
        })
    },
    compareByImportance (a, b) {
      if (a.importance > b.importance) {
        return -1
      }
      if (b.importance < a.importance) {
        return 0
      }
      return 1
    },
    deleteQuestion (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.designator,
        item_name: delete_data.designator,
        method: 'postQuestionAnswer',
        method_params: { question_id: delete_data.id, current_type: 'Position', current_resource_id: this.position_id, option_ids: '' }
      })
    },
    editClick (data) {
      this.create({ designator: 'position-questions-form', component_name: 'QuestionsForm', data, modal_title: data.info.applicant_text, resource_type: 'Position', resource_id: this.position_id, company_id: this.$route.query.company_id, position_status: this.$route.query.position_status })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
